
const colors = {
  dark: '#071802',
  dark2: '#054149',
  dark3: '#056c53',
  green: '#17B890',
  spotify: '#1DB954',
  light: '#9DC5BB',
  white: '#DEE5E5',
  purewhite: '#FFF',
  error: '#E43F6F'
};

const easeOutExpo = 'cubic-bezier(.16,1,.3,1)';

export { colors, easeOutExpo };
